export enum ReceiverSelectValues {
    CustomerEmail = 'CustomerEmail',
    CustomEmail = 'CustomEmail',
}
